export const styles = `
<style>
	/*
	Attantion! if you add some new params for styling purpose, 
	the funtion passAttributesToDialogBody needs to be updated in wdk-dialog.js
	*/

	:host {
		display: block;
		max-width: 600px;
		--inline-padding: 12px;
		/*line-height: 24px; EP: 27px */ /* Workaround for CSS line-height calculation: Will calculate scroll height wrong of the article, because our line height is lower than the renderbox of the Text. Nicht globalgmeacht, weil wir dann überall 2px mehr line-hieght haben. Nur lokal implementieren, wenn notwendig https://stackoverflow.com/questions/16443642/scroll-bars-showing-up-when-not-expecting-them-line-height-and-overflow-y-issue */
	}
	
	/*Fix for Chrome only (July 2024): When content is not wide enough the width of the 
	Dialog is to small and jumps second later to the right width.*/
	@media only screen and (min-width: 360px) {
		:host {
			min-width: 360px;
		}
		
		:host([mobile-center]) {
			min-width: calc(360px - 16px);
		}
	}
	
	@media only screen and (min-width: 375px) {
		:host {
			min-width: 375px;
		}
		
		:host([mobile-center]) {
			min-width: calc(375px - 16px);
		}
	}
	
	@media only screen and (min-width: 390px) {
		:host {
			min-width: 390px;
		}
		
		:host([mobile-center]) {
			min-width: calc(390px - 16px);
		}
	}
	
	@media only screen and (min-width: 425px) {
		:host {
			min-width: 425px;
		}
		
		:host([mobile-center]) {
			min-width: calc(425px - 16px);
		}
	}
	
	@media only screen and (min-width: 601px) {
		:host {
			--inline-padding: 24px;
			width: var(--wdk-dialog-width-desktop);
			min-width: auto !important;
			max-width: none;
		}
	}
	
	.dialogContent {
		display: flex;
		flex-flow: column;
		max-height: 80dvh; /* Default height */
		width: 100%;
		border-top-left-radius: var(--RADIUS_M);
		border-top-right-radius: var(--RADIUS_M);
		background-color: var(--wdk-dialog-body-default-bg-color, var(--COLOR_support_white_default));
	}
	
	.dialogContent:not(:has(header)) { /* if no closingX oder X is outside we don't have to reserve some space in dialogContent */	
		padding-top: 16px;
		max-height: calc(80dvh - 16px); 
	}
	
	:host([closing-x="inside"]) .dialogContent:not(:has(header)) { /* Reserve Space so that content does not run into ClosingX */
		padding-top: 48px;
		max-height: calc(80dvh - 48px);  
	}
	
	@media only screen and (max-width: 600px) { /* SM */
		:host([mobile-full-height]) .dialogContent {
			height: 100dvh; /* Default height when header is present */
			max-height: 100dvh;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}
		
		:host([mobile-full-height]) .dialogContent:not(:has(header)) { /* Full height without closingX, but no header */
			height: calc(100dvh - 16px); 
			max-height: calc(100dvh - 16px);
		}
		
		:host([closing-x="inside"][mobile-full-height]) .dialogContent:not(:has(header)) {
			height: calc(100dvh - 48px); 
			max-height: calc(100dvh - 48px);
		}
	}

	:host([mobile-center]) .dialogContent { /* If mobile-center we want to have the rounded border also for SM */
		border-bottom-left-radius: var(--RADIUS_M);
		border-bottom-right-radius: var(--RADIUS_M);
	}
	
	@media only screen and (min-width: 601px) { /* Rounded border in every case if we are in XL */
		.dialogContent {
			border-bottom-left-radius: var(--RADIUS_M);
			border-bottom-right-radius: var(--RADIUS_M);			
		}
	}
		
	/*:host([mobile-full-height]) .dialogContent {
		background-color: var(--COLOR_support_white_default);
	}*/
	
	.dialogContent > header {
		width: 100%;
	}
	
	.dialogContent > header h2 {
		display: flex;
		align-items: center;
		min-height: 60px;
		margin: 0;
		padding: 18px var(--inline-padding) var(--inline-padding) var(--inline-padding);
		font: var(--FONT_default_200);
		color: var(--COLOR_defaultText);
	}
	
	:host([closing-x="inside"]) .dialogContent > header h2 {
		padding: 18px 68px var(--inline-padding) var(--inline-padding);
	}
	
	.dialogContent > article {
		display: flex;
		flex-direction: column;
		padding: 0 var(--inline-padding) var(--inline-padding) var(--inline-padding);
		overflow-y: auto;
		flex-grow: 1;
	}
	
	.dialogContent:has(footer) > article {
		padding-bottom: 0;
	}
	
	.dialogContent > article::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}
	
	.dialogContent > article::-webkit-scrollbar-track {
		background: transparent;
		border-radius: var(--RADIUS_rounded);
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb {
		background: var(--COLOR_gray_400);
		border: 3px solid transparent;
		border-radius: var(--RADIUS_rounded);
		background-clip: content-box;
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb:hover {
		background: var(--COLOR_gray_300);
		background-clip: content-box;
	}
	
	/* .dialogContent > article ::slotted(form) {
		!*not sure if we should style the form here or if this should be styled outside the component*!
		  display: flex;
		flex-direction: column;
		height: 100%;
	}*/
	
	.dialogContent > footer {
		padding: 16px 24px;
	}
	
	@media only screen and (min-width: 375px) {
		.dialogContent > footer {
			padding: 24px;
		}
	}

	@media only screen and (min-width: 601px) {
		.dialogContent > footer {
			padding: 32px 24px;
		}
	}
	
	.dialogContent > footer ul {
		width: 100%;
		display: flex;
		flex-flow: wrap;
		gap: 20px;
		justify-content: space-between;
		margin: 0;
		padding: 0;
	}
	
	.dialogContent > footer ul li {
		flex-basis: calc(40% - 20px);
		flex-grow: 1;
		list-style: none;
		text-align: center;
		vertical-align: top;
		margin: 0;
		padding: 0;
	}
	
	/* Full width for Buttons if shown in 2 lines */
	.dialogContent > footer:has(li:nth-child(2)) ::slotted([slot^='button_']) {
		width: 100%;
	}
	
	/* Buttons always one below another */
	
	:host([buttons-vertical]) .dialogContent > footer ul {
		display: grid;
		grid-template-rows: auto;
		justify-content: center;
		gap: 8px;
	}
	
	:host([buttons-vertical]) .dialogContent > footer ul li {
		flex-basis: auto;
	}
</style>
`;
